module.exports = __webpack_public_path__ + "img/BAU Seniors_1.00afe3f4.jpg";